'use client';
import { RouteError } from '@repo/ui';

export default function ErrorBoundary({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return <RouteError error={error} reset={reset} app="onboarding" />;
}
